export const steps = [
  'Dashboard',
  'Edit company details',
  'Check the address',
  'Customer list',
  'Services',
  'Tickets'
]
